/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "urgencyhistory",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_contacts: null,
	_call: "",
});

function init() {
	this._contact = null;
	this._contacts = [];
	this.push(false);
}

function uninit() {
	this._contacts = null;
}

function listeners() {
	return {
		"availableurgencycontacts:updated": handle_available_contacts_update,
		"nexturgencycontact:updated": handle_next_contact_update,
	};
}

function triggers() {
	return {
		"start": start_urgency,
		"call": call_urgency,
		"cycle": cycle_urgency,
		"accept": accept_urgency,
		"cancel": cancel_urgency,
		"resume": handle_resume,
	};
}

function start_urgency(data) {
	var reason = data.reason;
	this._reason = reason;
	var contacts = this._contacts;
	this.api.urgency.history
		.create(contacts, reason)
		.then(handle_creation_success.bind(this));
}

function call_urgency() {
	var contact = this._contact;
	var reason = this._reason;
	var contacts = this._contacts;
	var call = this._call;
	this.api.banner.urgency(contact, reason);
	this.api.urgency.history.update(call, "call", contacts, contact);
}

function cycle_urgency() {
	var contacts = this._contacts;
	var call = this._call;
	this.api.urgency.history.update(call, "cycle", contacts);
}

function accept_urgency() {
	var accepter = this._contact;
	var contacts = this._contacts;
	var call = this._call;
	var reason = this._reason;

	this.api.banner.urgency_accepted(accepter, reason);
	this.api.urgency.history.update(call, "accept", contacts, accepter);
}

function cancel_urgency() {
	var contacts = this._contacts;
	var call = this._call;
	var reason = this._reason;

	this.api.banner.urgency_cancelled(reason);
	this.api.urgency.history.update(call, "cancel", contacts);
}

function handle_creation_success(call) {
	var id = call._id;
	this._call = id;
	this.dispatch("started", {
		call: id
	});
}

function handle_resume(data) {
	var call = data.call;
	var reason = data.reason;
	this._reason = reason;
	this._call = call;
	this.dispatch("started", {
		call: call
	});
}

function handle_available_contacts_update(contacts) {
	this._contacts = contacts;
}

function handle_next_contact_update(contact) {
	this._contact = contact;
}
